import n from "./_baseEach.js";
import p from "./isArrayLike.js";
var u = n, b = p;
function m(r, e) {
  var s = -1, a = b(r) ? Array(r.length) : [];
  return u(r, function(i, t, f) {
    a[++s] = e(i, t, f);
  }), a;
}
var v = m;
export {
  v as default
};
//# sourceMappingURL=_baseMap.js.map
